import { render } from "./card-flight.vue?vue&type=template&id=59029df6&scoped=true&ts=true"
import script from "./card-flight.vue?vue&type=script&lang=ts"
export * from "./card-flight.vue?vue&type=script&lang=ts"

import "./card-flight.vue?vue&type=style&index=0&id=59029df6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59029df6"]])

export default __exports__